import type z from 'zod/v4'
import { boolean, index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

export const LibrarySlider = pgTable(
  'library_slider',
  {
    id: uuid().notNull().primaryKey(),
    name: text().notNull(),
    description: text(),
    imageKey: text().notNull(),
    order: integer().notNull(),
    schoolUrl: text().notNull(),
    appUrl: text().notNull(),
    isActive: boolean().notNull().default(true),
    legacyBannerId: integer(),
    legacyNeonPerpustakaanHeaderId: uuid(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
  },
  (columns) => [
    index('library_banner_legacy_neon_perpustakaan_header_id_idx').on(columns.legacyNeonPerpustakaanHeaderId),
    index('library_banner_legacy_banner_id_idx').on(columns.legacyBannerId),
    index('library_banner_updated_at_idx').on(columns.updatedAt),
    index('library_banner_created_at_idx').on(columns.createdAt),
    index('library_banner_is_active_idx').on(columns.isActive),
  ],
)

export const InsertLibrarySliderSchema = createInsertSchema(LibrarySlider)
export const UpdateLibrarySliderSchema = createUpdateSchema(LibrarySlider)
  .omit({ id: true, legacyBannerId: true, legacyNeonPerpustakaanHeaderId: true })
  .partial()
export const SelectLibrarySliderSchema = createSelectSchema(LibrarySlider)

export type InsertLibrarySlider = typeof LibrarySlider.$inferInsert
export type UpdateLibrarySlider = z.infer<typeof UpdateLibrarySliderSchema>
export type SelectLibrarySlider = typeof LibrarySlider.$inferSelect
